import * as type from '../ActionTypes';
const initialState = {
  chatWithUser: {}
};

export default function chatReducer(state = initialState, action: any) {
  switch (action.type) {
    case type.GET_CHAT_WITH:
      return {
        ...state
      };

    case type.SAVE_CHAT_WITH:
      return {
        ...state,
        chatWithUser: action.payload
      };
    case type.RESET_CHAT_WITH:
      return {
        ...state,
        chatWithUser: {}
      };
    default:
      return state;
  }
}
